var inventorySource;

if (Shopify.locale === 'ar') {
  inventorySource = [
    {
      key: "ar",
      inStock: [true, false]
    }
  ];
} else {
  inventorySource = [
    {
      key: "en",
      inStock: [true, false]
    }
  ];
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // data.filters.inventorySources = inventorySource;
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      
      // const inventorySources = inventorySource;
      // data.inventorySources = JSON.stringify(inventorySources);
      return data;
    }
  );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        if(window.Shopify.locale == "ar") {
            data.credentials = {
                "apiKey": "UlIzSlZpa1I5UTcxN3l4bTVoNXpNcEdYaEtZMjI3dG5MQVhIZ0xIM1dtUUx0RkRjaDN6QUxkaytBbUVWTTZBNzdMZ0M3a00xcWNab2Q3Z2l2SFQ1NkR1Y1FhaEVyaE1aeU9FV3ZHWlAyWlE9",
                "storeId": "f77d19e8237711f190130a0c8095feae"
            }
        }
        try {

        data.search.configs.pagination.appendInExistingList = !0;
        if(Shopify.locale === 'ar'){
          document.body.classList.add('on-arabic-site');
        }
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = !0;
        data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
      if (Shopify.locale === "ar") {

      const arabicFacetLabels = {
        "Category": "الفئة",
        "Product Type": "نوع المنتج",
        "Brands": "العلامات التجارية",
        "Colors": "الألوان",
        "Price": "السعر",
        "Model": "الموديل",
        "Battery Capacity": "سعة البطارية",
        "Cable & Connector Type": "نوع الكابل والموصل",
        "Battery Size": "حجم البطارية",
        "Material": "المادة",
        "Connectivity Technology": "تقنية الاتصال",
        "Camera HD Type": "نوع دقة الكاميرا",
        "Camera Features": "ميزات الكاميرا",
        "Plug Type": "نوع القابس",
        "Connection Type": "نوع الاتصال",
        "Compatible Device": "الأجهزة المتوافقة",
        "Speaker Features": "ميزات السماعة",
        "Availability": "التوفر"
      };

      data.search.configs.facets.configs.forEach((facet) => {
        if (arabicFacetLabels[facet.label]) {
          facet.label = arabicFacetLabels[facet.label];
        }
      });

    }
      if (Shopify.locale === "ar") {

    const arabicSuggestions = {
      "Earpods": "سماعات الأذن",
      "Power Bank": "باور بنك",
      "Cables": "كابلات",
      "Cases": "حافظات",
      "Gadgets": "أجهزة إلكترونية",
      "Gaming Controller": "وحدة تحكم الألعاب",
      "Travel Adapter": "محول السفر"
    };

    const suggestions =
      data?.autocomplete?.configs?.defaultBehaviour?.suggestions?.defaultPool || [];

    suggestions.forEach((item) => {
      if (arabicSuggestions[item.value]) {
        item.value = arabicSuggestions[item.value];
        item.valueHighlighted = arabicSuggestions[item.valueHighlighted] || arabicSuggestions[item.value];
      }
    });
      if (data?.autocomplete?.topProducts) {
        data.autocomplete.topProducts.title = "أفضل المنتجات";
      }

      if (data?.autocomplete?.trendingSearches) {
        data.autocomplete.trendingSearches.title = "عمليات البحث الشائعة";
      }
  if (data?.autocomplete?.menu?.others) {
    data.autocomplete.menu.others.title = "عمليات البحث الشائعة";
  }
  }
  if (Shopify.locale === "ar") {

    const arabicPlaceholders = {
      "Search for Earpods": "ابحث عن سماعات الأذن",
      "Search for Power Bank": "ابحث عن باور بنك",
      "Search for Cables": "ابحث عن كابلات",
      "Search for Cases": "ابحث عن حافظات",
      "Search for Gadgets": "ابحث عن أجهزة إلكترونية",
      "Search for Gaming Controller": "ابحث عن وحدة تحكم الألعاب",
      "Search for Travel Adapter": "ابحث عن محول السفر"
    };

    const placeholders = data?.autocomplete?.searchBar?.animatedPlaceholders || [];

    data.autocomplete.searchBar.animatedPlaceholders = placeholders.map((text) => {
      return arabicPlaceholders[text] || text;
    });

  }
    if (Shopify.locale === "ar") {

    const arabicMap = {
      "In Stock": "متوفر",
      "Out of Stock": "غير متوفر",

      "Phone Holder": "حامل الهاتف",
      "Data Cables": "كابلات البيانات",
      "Wireless Speakers": "مكبرات صوت لاسلكية",
      "Gaming": "الألعاب",
      "Cooling Fans": "مراوح تبريد",
      "Car Chargers": "شواحن السيارة",
      "Chargers": "شواحن",
      "IPAD COVERS": "أغطية الآيباد",
      "Power Banks": "باور بانك",
      "Smart Watches": "ساعات ذكية",
      "Gaming Controller": "وحدة تحكم الألعاب",
      "Wireless Power Banks": "باور بانك لاسلكي",
      "Fans": "مراوح",
      "Earpods": "سماعات أذن",
      "Headphones": "سماعات رأس",
      "Mobile Stands": "حوامل الهاتف",
      "OTG / Connectors": "موصلات OTG",
      "USB Hub": "موزع USB",
      "gadgets": "أجهزة إلكترونية",
      "Conversion Adapter": "محول تحويل",

      "USB": "USB",
      "Wireless": "لاسلكي",
      "Bluetooth": "بلوتوث",
      "Wired": "سلكي",
      "AUX": "AUX",
      "HDMI": "HDMI",
      "Micro USB": "مايكرو USB",

      "Smartphone": "هاتف ذكي",
      "Tablet": "جهاز لوحي",
      "Digital camera": "كاميرا رقمية",
      "Smartwatch": "ساعة ذكية",
      "Wireless earbud": "سماعة أذن لاسلكية",

      "Volume control": "التحكم في الصوت",
      "Built-in amplifier": "مضخم صوت مدمج",
      "Auto pairing": "اقتران تلقائي",
      "Shockproof": "مقاوم للصدمات",

      "Plastic": "بلاستيك",
      "Aluminum": "ألمنيوم",

      "UK": "مقبس بريطاني",
      "EU": "مقبس أوروبي",
      "US": "مقبس أمريكي",

      "Black": "أسود",
      "White": "أبيض",
      "Gray": "رمادي",
      "Grey": "رمادي",
      "Red": "أحمر",
      "Blue": "أزرق",
      "Green": "أخضر",
      "Silver": "فضي",
      "Purple": "بنفسجي",
      "Orange": "برتقالي",
      "Pink": "وردي",
      "Gold": "ذهبي",
      "Brown": "بني",
      "Beige": "بيج",
      "Multicolor": "متعدد الألوان",
      "Dark blue": "أزرق داكن",
      "Dark Blue": "أزرق داكن",
      "Navy": "كحلي",
      "Rose gold": "روز ذهبي"
    };

    window.wizzyConfig.pageStore?.searchedResponse?.facets?.forEach((facet) => {

      if (Array.isArray(facet.data)) {

        facet.data.forEach((item) => {

          if (arabicMap[item.label]) {
            item.label = arabicMap[item.label];
          }

          if (item.data?.value && arabicMap[item.data.value]) {
            item.data.value = arabicMap[item.data.value];
          }

        });

      }

    });

  }
        } catch (error) {
          console.log("error",error);
        }

        return data;
      },
      3
    );
    window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  function (data) {
   if (Shopify.locale === "ar") {

    const arabicMap = {
      "In Stock": "متوفر",
      "Out of Stock": "غير متوفر",

      "Phone Holder": "حامل الهاتف",
      "Data Cables": "كابلات البيانات",
      "Wireless Speakers": "مكبرات صوت لاسلكية",
      "Gaming": "الألعاب",
      "Cooling Fans": "مراوح تبريد",
      "Car Chargers": "شواحن السيارة",
      "Chargers": "شواحن",
      "IPAD COVERS": "أغطية الآيباد",
      "Power Banks": "باور بانك",
      "Smart Watches": "ساعات ذكية",
      "Gaming Controller": "وحدة تحكم الألعاب",
      "Wireless Power Banks": "باور بانك لاسلكي",
      "Fans": "مراوح",
      "Earpods": "سماعات أذن",
      "Headphones": "سماعات رأس",
      "Mobile Stands": "حوامل الهاتف",
      "OTG / Connectors": "موصلات OTG",
      "USB Hub": "موزع USB",
      "gadgets": "أجهزة إلكترونية",
      "Conversion Adapter": "محول تحويل",

      "USB": "USB",
      "Wireless": "لاسلكي",
      "Bluetooth": "بلوتوث",
      "Wired": "سلكي",
      "AUX": "AUX",
      "HDMI": "HDMI",
      "Micro USB": "مايكرو USB",

      "Smartphone": "هاتف ذكي",
      "Tablet": "جهاز لوحي",
      "Digital camera": "كاميرا رقمية",
      "Smartwatch": "ساعة ذكية",
      "Wireless earbud": "سماعة أذن لاسلكية",

      "Volume control": "التحكم في الصوت",
      "Built-in amplifier": "مضخم صوت مدمج",
      "Auto pairing": "اقتران تلقائي",
      "Shockproof": "مقاوم للصدمات",

      "Plastic": "بلاستيك",
      "Aluminum": "ألمنيوم",

      "UK": "مقبس بريطاني",
      "EU": "مقبس أوروبي",
      "US": "مقبس أمريكي",

      "Black": "أسود",
      "White": "أبيض",
      "Gray": "رمادي",
      "Grey": "رمادي",
      "Red": "أحمر",
      "Blue": "أزرق",
      "Green": "أخضر",
      "Silver": "فضي",
      "Purple": "بنفسجي",
      "Orange": "برتقالي",
      "Pink": "وردي",
      "Gold": "ذهبي",
      "Brown": "بني",
      "Beige": "بيج",
      "Multicolor": "متعدد الألوان",
      "Dark blue": "أزرق داكن",
      "Dark Blue": "أزرق داكن",
      "Navy": "كحلي",
      "Rose gold": "روز ذهبي",
      "Hot Pink": "وردي فاقع",

      "Rainbow pink": "وردي قوس قزح",
      "Rainbow red": "أحمر قوس قزح",
      "Rose gold": "روز ذهبي",
      "White/Orange": "أبيض / برتقالي",
      "gold black": "أسود ذهبي",
      "Rainbow blue": "أزرق قوس قزح",

      "Mobile Phone Stands": "حوامل الهاتف المحمول",
    "Speakers": "مكبرات الصوت",
    "USB Cables": "كابلات USB",
    "Power Adapters & Chargers": "محولات الطاقة والشواحن",
    "Handheld Device Accessories": "ملحقات الأجهزة المحمولة",
    "USB & FireWire Hubs": "موزعات USB و FireWire",
    "Dashboard Mounts": "حوامل لوحة القيادة",
    "Windshield Mounts": "حوامل الزجاج الأمامي",
    "Wireless Chargers": "شواحن لاسلكية",
    "In-Ear Headphones": "سماعات داخل الأذن",
    "PDA Cases": "حافظات الأجهزة المحمولة",
    "Storage & Data Transfer Cables": "كابلات نقل البيانات والتخزين",
    "Tablet Computer Docks & Stands": "حوامل وأرصفة الأجهزة اللوحية",
    "Microphones": "ميكروفونات",
    "Mobile Phone Cases": "حافظات الهاتف المحمول",
    "Motor Vehicle A/V Players & In-Dash Systems": "أنظمة الصوت والفيديو للسيارات",
    "Power Stations": "محطات طاقة",
    "Power Strips & Surge Suppressors": "مشتركات الكهرباء ومانعات زيادة الجهد",


    "Hoco": "هوكو",
    "Earldom": "إيرلدوم",
    "Saif Al Najmi Kw": "سيف النجمي الكويت",
    "Saif Al Najmi": "سيف النجمي",
    "JOYROOM": "جويروم",
    "ACEFAST": "ايسفاست",
    "yesido": "يسيدو",
    "LDNIO": "إلدنيو",
    "Mcdodo": "مكدودو",
    "MOXOM": "موكسوم",
    "Porodo": "بورودو",
    "MOCOME": "موكوم",
    "Baseus": "بايوس",
    "wekome": "ويكوم",
    "Green Lion": "جرين لايون",
    "My Store": "متجري",
    "SING-E": "سينغ إي",
    "LITO": "ليتو",
    "Labubu": "لابوبو",
    "ONIKUMA": "أونيكوما",
    "WST": "دبليو إس تي",
    "viplatina": "فيبلاتينا",

  "iPhone 17 PRO": "آيفون 17 برو",
  "iPhone 17 PRO MAX": "آيفون 17 برو ماكس",


  "LIGHTNING CABLE": "كابل لايتنينج",
  "Type-C to Lightning Cable": "كابل Type-C إلى لايتنينج",
  "4K HDMI Cable": "كابل HDMI 4K",
  "Type-C to Type-C Cable": "كابل Type-C إلى Type-C",

    "System & Power Cables": "كابلات النظام والطاقة",
  "AUX Cables": "كابلات AUX",
  "Telephone Cables": "كابلات الهاتف",
  "Adapters": "محولات",
  "Audio & Video Cable Adapters & Couplers": "محولات وموصلات كابلات الصوت والفيديو",
  "Audio & Video Cables": "كابلات الصوت والفيديو",
  "Cable Clips": "مشابك الكابلات",
  "HDMI Cables": "كابلات HDMI",
  "iPhone 17 PRO MAX": "آيفون 17 برو ماكس",
  "Game Remotes": "أجهزة تحكم الألعاب",
  "Game Controller Accessories": "ملحقات وحدات تحكم الألعاب",
  "Game Controllers": "وحدات تحكم الألعاب",
  "Gaming Pads": "أذرع تحكم الألعاب",
  "Home Game Console Accessories": "ملحقات أجهزة الألعاب المنزلية",
  "Joystick Controllers": "عصي تحكم الألعاب",

    "Headphones & Headsets": "سماعات الرأس وسماعات الهيدسيت",
  "Vehicle Jump Starters": "مشغلات تشغيل السيارة",
  "Multimedia Projectors": "أجهزة عرض الوسائط المتعددة",
  "Headsets": "سماعات هيدسيت",
  "Projection Screens": "شاشات العرض",
  "AC Compressors": "ضواغط مكيف الهواء",
  "Compressors": "ضواغط",
  "Hard Drive Enclosures & Mounts": "حاويات وحوامل الأقراص الصلبة",
  "Incense Holders": "حوامل البخور",
  "Karaoke Systems": "أنظمة الكاريوكي",
  "Memory Card Readers": "قارئات بطاقات الذاكرة",
  "Over-Ear Headphones": "سماعات رأس فوق الأذن",
  "Public Address Systems": "أنظمة الصوت العامة",
    "Noise cancellation": "إلغاء الضوضاء",
  "Voice control": "التحكم الصوتي",
  "Weather resistant": "مقاوم للعوامل الجوية",

  "In Stock": "في الأوراق المالية",
  "Out of Stock": "إنتهى من المخزن",
  "BOOMS": "بومز",
  "CineCast": "سينكاست",
  "CoseCase": "كوسكيس",
  "Equantu": "إيكوانتو",

  "Yellow": "أصفر",
  "Geometric": "هندسي",
  "Camouflage": "مموه",
  "Clear": "شفاف",
  "Cream/Beige": "كريمي / بيج",
  "Desert white": "أبيض صحراوي",
  "Floral": "زهري",
  "Light Blue": "أزرق فاتح",
  "sky blue": "أزرق سماوي",
  "dark pink": "وردي داكن",
  "dark purple": "بنفسجي داكن",
  "milky white": "أبيض حليبي",
  "Computer Risers & Stands": "حوامل ورافعات أجهزة الكمبيوتر",

  "11 PRO MAX": "11 برو ماكس",
  "16 PRO": "16 برو",
  "16 PRO MAX": "16 برو ماكس",
  "XS MAX": "XS ماكس"

};

data.response.payload.facets.forEach((facet) => {

  if (Array.isArray(facet.data)) {

    facet.data.forEach((item) => {

      const cleanLabel = item.label
        ?.replace(/[\u200B-\u200D\uFEFF\u2060]/g, '') // remove invisible chars
        ?.replace(/\s+/g, ' ') // normalize spaces
        ?.trim();

      if (arabicMap[cleanLabel]) {
        item.label = arabicMap[cleanLabel];
      }

      if (item.data?.value) {
        const cleanValue = item.data.value
          ?.replace(/[\u200B-\u200D\uFEFF\u2060]/g, '')
          ?.replace(/\s+/g, ' ')
          ?.trim();

        if (arabicMap[cleanValue]) {
          item.data.value = arabicMap[cleanValue];
        }
      }

    });

  }

});

  }
console.log("data",data);

return data;
  });
window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (data) {
    try {
        // data.inventorySources = JSON.stringify(inventorySource);
      if(document.querySelector('.product-media-modal.media-modal')){
        document.querySelector('.product-media-modal.media-modal').style.display = "none";
      }
    } catch (error) {
      console.log("error",error);
    }

    return data;
  }
);
  
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (data) {
        if(window.Shopify.locale == "ar") {
            data.credentials = {
                "apiKey": "UlIzSlZpa1I5UTcxN3l4bTVoNXpNcEdYaEtZMjI3dG5MQVhIZ0xIM1dtUUx0RkRjaDN6QUxkaytBbUVWTTZBNzdMZ0M3a00xcWNab2Q3Z2l2SFQ1NkR1Y1FhaEVyaE1aeU9FV3ZHWlAyWlE9",
                "storeId": "f77d19e8237711f190130a0c8095feae"
            }
        }
      if (Shopify.locale === "ar") {

      const arabicSuggestions = {
        "Earpods": "سماعات الأذن",
        "Power Bank": "باور بنك",
        "Cables": "كابلات",
        "Cases": "حافظات",
        "Gadgets": "أجهزة إلكترونية",
        "Gaming Controller": "وحدة تحكم الألعاب",
        "Travel Adapter": "محول السفر"
      };

      const suggestions =
        data?.autocomplete?.configs?.defaultBehaviour?.suggestions?.defaultPool || [];

      suggestions.forEach((item) => {
        if (arabicSuggestions[item.value]) {
          item.value = arabicSuggestions[item.value];
          item.valueHighlighted = arabicSuggestions[item.valueHighlighted] || arabicSuggestions[item.value];
        }
      });
        if (data?.autocomplete?.topProducts) {
          data.autocomplete.topProducts.title = "أفضل المنتجات";
        }

        if (data?.autocomplete?.trendingSearches) {
          data.autocomplete.trendingSearches.title = "عمليات البحث الشائعة";
        }
  if (data?.autocomplete?.menu?.others) {
    data.autocomplete.menu.others.title = "عمليات البحث الشائعة";
  }
    }
          if (Shopify.locale === "ar") {
          const arabicFacetLabels = {
            "Category": "الفئة",
            "Product Type": "نوع المنتج",
            "Brands": "العلامات التجارية",
            "Colors": "الألوان",
            "Price": "السعر",
            "Model": "الموديل",
            "Battery Capacity": "سعة البطارية",
            "Cable & Connector Type": "نوع الكابل والموصل",
            "Battery Size": "حجم البطارية",
            "Material": "المادة",
            "Connectivity Technology": "تقنية الاتصال",
            "Camera HD Type": "نوع دقة الكاميرا",
            "Camera Features": "ميزات الكاميرا",
            "Plug Type": "نوع القابس",
            "Connection Type": "نوع الاتصال",
            "Compatible Device": "الأجهزة المتوافقة",
            "Speaker Features": "ميزات السماعة",
            "Availability": "التوفر"
          };

          data.search.configs.facets.configs.forEach((facet) => {
            if (arabicFacetLabels[facet.label]) {
              facet.label = arabicFacetLabels[facet.label];
            }
          });

        }
        if (Shopify.locale === "ar") {

        const arabicPlaceholders = {
          "Search for Earpods": "ابحث عن سماعات الأذن",
          "Search for Power Bank": "ابحث عن باور بنك",
          "Search for Cables": "ابحث عن كابلات",
          "Search for Cases": "ابحث عن حافظات",
          "Search for Gadgets": "ابحث عن أجهزة إلكترونية",
          "Search for Gaming Controller": "ابحث عن وحدة تحكم الألعاب",
          "Search for Travel Adapter": "ابحث عن محول السفر"
        };

        const placeholders = data?.autocomplete?.searchBar?.animatedPlaceholders || [];

        data.autocomplete.searchBar.animatedPlaceholders = placeholders.map((text) => {
          return arabicPlaceholders[text] || text;
        });

      }
          if (Shopify.locale === "ar") {

    const arabicMap = {
      "In Stock": "متوفر",
      "Out of Stock": "غير متوفر",

      "Phone Holder": "حامل الهاتف",
      "Data Cables": "كابلات البيانات",
      "Wireless Speakers": "مكبرات صوت لاسلكية",
      "Gaming": "الألعاب",
      "Cooling Fans": "مراوح تبريد",
      "Car Chargers": "شواحن السيارة",
      "Chargers": "شواحن",
      "IPAD COVERS": "أغطية الآيباد",
      "Power Banks": "باور بانك",
      "Smart Watches": "ساعات ذكية",
      "Gaming Controller": "وحدة تحكم الألعاب",
      "Wireless Power Banks": "باور بانك لاسلكي",
      "Fans": "مراوح",
      "Earpods": "سماعات أذن",
      "Headphones": "سماعات رأس",
      "Mobile Stands": "حوامل الهاتف",
      "OTG / Connectors": "موصلات OTG",
      "USB Hub": "موزع USB",
      "gadgets": "أجهزة إلكترونية",
      "Conversion Adapter": "محول التحويل",

      "USB": "USB",
      "Wireless": "لاسلكي",
      "Bluetooth": "بلوتوث",
      "Wired": "سلكي",
      "AUX": "AUX",
      "HDMI": "HDMI",
      "Micro USB": "مايكرو USB",

      "Smartphone": "هاتف ذكي",
      "Tablet": "جهاز لوحي",
      "Digital camera": "كاميرا رقمية",
      "Smartwatch": "ساعة ذكية",
      "Wireless earbud": "سماعة أذن لاسلكية",

      "Volume control": "التحكم في الصوت",
      "Built-in amplifier": "مضخم صوت مدمج",
      "Auto pairing": "اقتران تلقائي",
      "Shockproof": "مقاوم للصدمات",

      "Plastic": "بلاستيك",
      "Aluminum": "ألمنيوم",

      "UK": "مقبس بريطاني",
      "EU": "مقبس أوروبي",
      "US": "مقبس أمريكي",

      "Black": "أسود",
      "White": "أبيض",
      "Gray": "رمادي",
      "Grey": "رمادي",
      "Red": "أحمر",
      "Blue": "أزرق",
      "Green": "أخضر",
      "Silver": "فضي",
      "Purple": "بنفسجي",
      "Orange": "برتقالي",
      "Pink": "وردي",
      "Gold": "ذهبي",
      "Brown": "بني",
      "Beige": "بيج",
      "Multicolor": "متعدد الألوان",
      "Dark blue": "أزرق داكن",
      "Dark Blue": "أزرق داكن",
      "Navy": "كحلي",
      "Rose gold": "روز ذهبي",
      "Yellow": "أصفر",
      "Geometric": "هندسي",
      "Camouflage": "مموه",
      "Clear": "شفاف",
      "Cream/Beige": "كريمي / بيج",
      "Desert white": "أبيض صحراوي",
      "Floral": "زهري",
      "Light Blue": "أزرق فاتح",
      "sky blue": "أزرق سماوي",
      "dark pink": "وردي داكن",
      "dark purple": "بنفسجي داكن",
      "milky white": "أبيض حليبي"
    };

    window.wizzyConfig.pageStore?.searchedResponse?.facets?.forEach((facet) => {

      if (Array.isArray(facet.data)) {

        facet.data.forEach((item) => {

          if (arabicMap[item.label]) {
            item.label = arabicMap[item.label];
          }

          if (item.data?.value && arabicMap[item.data.value]) {
            item.data.value = arabicMap[item.data.value];
          }

        });

      }

    });

  }
        data.search.configs.pagination.appendInExistingList = !0;
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = !0;
        data.common.lazyDOMConfig.contentDOMIdentifiers = ["body main"];
        return data;
      },
      3
    );
function transformSwatches(swatchesObj) {

  if (!swatchesObj || typeof swatchesObj !== "object") {
    return [];
  }

  const locale = (window.Shopify && Shopify.locale) ? Shopify.locale : "en";

  const swatches = Object.values(swatchesObj)
    .filter(swatch => swatch && swatch.values && swatch.values.length)
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((swatch, index) => ({
      key: swatch.key,
      isPrimary: index === 0,
      values: swatch.values.map(v => {
        const val = Array.isArray(v.value) ? v.value[0] : v.value;

        return {
          variationId: `${v.variationId}_${locale}`,  
          inStock: v.inStock,
          value: val,
          swatchValue: val,
          isSwatch: true,
          isVisualSwatch: true,
          isURLSwatch: false,
          isSelected: false,
          image: v.image || ''
        };
      })
    }));

  return swatches;
}
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (products) {
        try {
          

        products.forEach(function (product) {

  product.swatches = transformSwatches(product.swatches);
  if (product.swatches && product.images && product.images.length) {
    product.swatches.forEach(function (swatch) {
      if (!swatch.values) return;
      swatch.values.forEach(function (val, idx) {
        if (!val.image && product.images[idx]) {
          val.image = product.images[idx];
        }
      });
    });
  }
        //   product.hasSwatches = !!(product.swatches && product.swatches.length > 0);
        // if (product.swatches) {
        //   product.swatches.forEach(function (swatch) {
        //     if (!swatch.values) return;
        //     swatch.values.forEach(function (val) {
        //       if (!val.isSwatch && val.value && !val.swatchValue) {
        //         val.isSwatch = true;
        //         val.isVisualSwatch = true;
        //         val.swatchValue = val.value.replace(/\s+/g, "").toLowerCase();
        //       }
        //       if (val.swatchValue && typeof val.swatchValue === "string" &&
        //           !val.swatchValue.startsWith("#") &&
        //           !val.swatchValue.startsWith("http") &&
        //           !val.swatchValue.startsWith("//") &&
        //           !val.swatchValue.startsWith("rgb")) {
        //         val.swatchValue = val.swatchValue.replace(/\s+/g, "").toLowerCase();
        //       }
        //     });
        //   });
        // }
          if (!product.attributes) return;
          product.attributes.forEach(function (attr) {
            if (attr.id === "product_vendor") {
              try { product.vendor = attr.values[0].value[0]; } catch (e) {}
            }
            if (attr.id === "product_description_tag_global") {
              try {
                var raw = attr.values[0].value[0];
                var tmp = document.createElement("div");
                tmp.innerHTML = raw;
                var text = tmp.textContent || tmp.innerText || "";
                var words = text.split(/\s+/);
                product.description = words.slice(0, 18).join(" ");
                if (words.length > 18) product.description += "...";
              } catch (e) {}
            }
            if(Shopify.locale === "ar"){
            if (attr.id === "product_arabic_name") {
              product.name = attr.values[0].value[0];
            }
          }


          });
           if(Shopify.locale === "ar"){
            product.isAr = true;
          const urlObj = new URL(product.url);
          if (urlObj.pathname.startsWith('/products/') && !urlObj.pathname.startsWith('/ar/')) {
              urlObj.pathname = '/ar' + urlObj.pathname;
          }
          product.url = urlObj.toString();
          }
        // if (typeof product.id === "string" && product.id !== "") {
        //     product.id = product.id.replace(/_(en|ar)$/, "");
        //   }

        //   if (typeof product.groupId === "string" && product.groupId !== "") {
        //     product.groupId = product.groupId.replace(/_(en|ar)$/, "");
        //   }
        });
    } catch (error) {
         console.log("error",error); 
    }
        return products;
      }
    );
  
    function initWizzyModalOpeners() {
      var container = document.querySelector(".wizzy-search-results-list");
      if (!container) return;
  
      container.querySelectorAll("modal-opener").forEach(function (opener) {
        var btn = opener.querySelector("button");
        if (!btn || btn._wizzyModalBound) return;
        btn._wizzyModalBound = true;
        btn.addEventListener("click", function (e) {
          if (btn.classList.contains("loading")) return;
          e.preventDefault();
          e.stopPropagation();
          var modalSelector = opener.getAttribute("data-modal");
          var modal = document.querySelector(modalSelector);
          if (modal && typeof modal.show === "function") {
            modal.show(btn);
          }
        });
      });
    }
  
    function initWizzyBulkAdd() {
      var container = document.querySelector(".wizzy-search-results-list");
      if (!container) return;
  
      container.querySelectorAll(".wizzy-bulk-add").forEach(function (bulk) {
        if (bulk._wizzyBulkBound) return;
        bulk._wizzyBulkBound = true;
  
        var input = bulk.querySelector(".quantity__input");
        if (!input) return;
  
        var minusBtn = bulk.querySelector('button[name="minus"]');
        var plusBtn = bulk.querySelector('button[name="plus"]');
        var progressBar = bulk.querySelector(".progress-bar-container");
        var debounceTimer = null;
  
        function updateCart(qty) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            var variantId = bulk.dataset.id;
            if (progressBar) progressBar.classList.remove("hidden");
  
            var updates = {};
            updates[variantId] = qty;
  
            fetch(window.routes.cart_update_url, {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({
                updates: updates,
                sections: ["cart-icon-bubble", "cart-drawer"],
                sections_url: window.location.pathname
              })
            })
              .then(function (r) { return r.json(); })
              .then(function (state) {
                input.setAttribute("value", qty);
                input.setAttribute("data-cart-quantity", qty);
  
                var bubbleEl = document.getElementById("cart-icon-bubble");
                if (bubbleEl && state.sections && state.sections["cart-icon-bubble"]) {
                  var doc = new DOMParser().parseFromString(state.sections["cart-icon-bubble"], "text/html");
                  var newContent = doc.querySelector(".shopify-section");
                  if (newContent) bubbleEl.innerHTML = newContent.innerHTML;
                }
  
                var drawerEl = document.getElementById("CartDrawer");
                if (drawerEl && state.sections && state.sections["cart-drawer"]) {
                  var doc2 = new DOMParser().parseFromString(state.sections["cart-drawer"], "text/html");
                  var newDrawer = doc2.querySelector("#CartDrawer");
                  if (newDrawer) {
                    drawerEl.innerHTML = newDrawer.innerHTML;
                    if (drawerEl.parentElement) {
                      if (state.items.length > 0) {
                        drawerEl.parentElement.classList.remove("is-empty");
                      } else {
                        drawerEl.parentElement.classList.add("is-empty");
                      }
                    }
                  }
                }
  
                if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "quick-add",
                    cartData: state
                  });
                }
              })
              .catch(function (err) { console.error(err); })
              .finally(function () {
                if (progressBar) progressBar.classList.add("hidden");
              });
          }, 300);
        }
  
        if (plusBtn) {
          plusBtn.addEventListener("click", function (e) {
            e.preventDefault();
            var prev = input.value;
            if (parseInt(input.dataset.min) > parseInt(input.step) && input.value == "0") {
              input.value = input.dataset.min;
            } else {
              input.stepUp();
            }
            if (prev !== input.value) updateCart(parseInt(input.value));
          });
        }
  
        if (minusBtn) {
          minusBtn.addEventListener("click", function (e) {
            e.preventDefault();
            var prev = input.value;
            input.stepDown();
            if (prev !== input.value) updateCart(parseInt(input.value));
          });
        }
  
        input.addEventListener("change", function () {
          updateCart(parseInt(input.value));
        });
      });
    }

    function initWizzySwatchClickRedirect() {
      var container = document.querySelector('.wizzy-search-results-list');
      if (!container) return;

      container.querySelectorAll('.product-item-swatch-group').forEach(function (group) {
        if (group._wizzySwatchGroupBound) return;
        group._wizzySwatchGroupBound = true;
        group.addEventListener('mouseleave', function () {
          var card = group.closest('.wizzy-result-product');
          if (!card) return;
          var img = card.querySelector('.card__media img');
          if (img && card._wizzyOriginalSrc) {
            img.src = card._wizzyOriginalSrc;
            delete card._wizzyOriginalSrc;
          }
        });
      });

      container.querySelectorAll('.product-item-swatch-item').forEach(function (item) {
        if (item._wizzySwatchClickBound) return;
        item._wizzySwatchClickBound = true;

        item.addEventListener('mouseenter', function () {
          var variantImage = item.getAttribute('data-variant-image');
          if (!variantImage) return;
          var card = item.closest('.wizzy-result-product');
          if (!card) return;
          var img = card.querySelector('.card__media img');
          if (!img) return;
          if (!card._wizzyOriginalSrc) card._wizzyOriginalSrc = img.src;
          img.src = variantImage;
        });

        item.addEventListener('click', function () {
          var card = item.closest('.wizzy-result-product');
          if (!card) return;
          var productInfo = card.querySelector('product-info');
          var url = productInfo ? productInfo.getAttribute('data-url') : null;
          if (!url) {
            var link = card.querySelector('a[href]');
            if (link) url = link.getAttribute('href');
          }
          if (!url) return;
          var variantId = item.getAttribute('data-variationid') || '';
          variantId = variantId.replace(/_(en|ar)$/, '');
          if (variantId) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId;
          window.location.href = url;
        });
      });
    }
  
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".js-wizzy-choose-options");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
  
      var modal = document.querySelector("#WizzyBulkAddModal");
      var contentDiv = document.getElementById("WizzyBulkAddContent");
      if (!modal || !contentDiv) return;
  
      btn.classList.add("loading");
      var spinner = btn.querySelector(".loading__spinner");
      if (spinner) spinner.classList.remove("hidden");
  
      var productUrl = btn.getAttribute("data-product-url").split("?")[0];
      var productTitle = btn.getAttribute("data-product-title") || "";
      var productImage = btn.getAttribute("data-product-image") || "";
  
      var headerHtml =
        '<div class="quick-add__content-info__media">' +
          '<div class="quick-add__info">' +
            (productImage
              ? '<div class="quick-add__product-media"><div class="quick-add__product-container global-media-settings">' +
                '<img src="' + productImage + '" width="150" height="150" loading="lazy" alt="' + productTitle.replace(/"/g, "&quot;") + '">' +
                '</div></div>'
              : "") +
          '</div>' +
          '<div class="quick-add-modal__content-info--bulk-details">' +
            '<div><h3>' + productTitle + '</h3></div>' +
            '<a href="' + productUrl + '" class="link product__view-details animate-arrow small-hide">' +
              'View full details ' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" width="14" height="10"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>' +
            '</a>' +
          '</div>' +
        '</div>';
  
      contentDiv.innerHTML =
        headerHtml +
        '<div class="wizzy-bulk-order-loading" style="display:flex;justify-content:center;padding:2rem;">' +
          '<div class="loading__spinner"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>' +
        '</div>';
  
      if (typeof modal.show === "function") {
        modal.show(btn);
      } else {
        modal.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");
      }
  
      fetch(productUrl + "?section_id=bulk-quick-order-list")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var source = doc.querySelector(".quick-order-list-container");
          if (source) {
            var loadingEl = contentDiv.querySelector(".wizzy-bulk-order-loading");
            if (loadingEl) loadingEl.remove();
            var orderDiv = document.createElement("div");
            orderDiv.innerHTML = source.parentNode.innerHTML;
            contentDiv.appendChild(orderDiv);
  
            orderDiv.querySelectorAll("script").forEach(function (oldScript) {
              var newScript = document.createElement("script");
              Array.from(oldScript.attributes).forEach(function (attr) {
                newScript.setAttribute(attr.name, attr.value);
              });
              newScript.appendChild(document.createTextNode(oldScript.innerHTML));
              oldScript.parentNode.replaceChild(newScript, oldScript);
            });
          } else {
            var loadingEl = contentDiv.querySelector(".wizzy-bulk-order-loading");
            if (loadingEl) loadingEl.innerHTML = "<p>Could not load product options.</p>";
          }
        })
        .catch(function (err) {
          console.error(err);
          var loadingEl = contentDiv.querySelector(".wizzy-bulk-order-loading");
          if (loadingEl) loadingEl.innerHTML = "<p>Error loading product options.</p>";
        })
        .finally(function () {
          btn.classList.remove("loading");
          if (spinner) spinner.classList.add("hidden");
        });
    });
  
    function syncCartQuantities() {
      var resultsList = document.querySelector(".wizzy-search-results-list");
      if (!resultsList) return;
  
      fetch(
        (window.routes ? window.routes.cart_url : "/cart") + ".js",
        { headers: { "Accept": "application/json" } }
      )
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var qtyMap = {};
          cart.items.forEach(function (item) {
            qtyMap[item.variant_id] = (qtyMap[item.variant_id] || 0) + item.quantity;
          });
  
          resultsList.querySelectorAll(".wizzy-bulk-add").forEach(function (bulk) {
            var variantId = bulk.dataset.id;
            var input = bulk.querySelector(".quantity__input");
            if (!input) return;
            var qty = qtyMap[variantId] || 0;
            input.value = qty;
            input.setAttribute("value", qty);
            input.setAttribute("data-cart-quantity", qty);
          });
        })
        .catch(function () {});
    }
    function translateWizzySortUI() {
    if (!window.wizzyStrings || !window.wizzyStrings.sortLabels) return;
    var labels = window.wizzyStrings.sortLabels;

    document.querySelectorAll(".wizzy-common-select-label").forEach(function (el) {
      if (window.wizzyStrings.sortBy) el.textContent = window.wizzyStrings.sortBy;
    });

    document.querySelectorAll(".wizzy-common-select-option").forEach(function (el) {
      var key = el.textContent.trim();
      if (labels[key]) {
        el.textContent = labels[key];
        el.setAttribute("title", labels[key]);
      }
    });

    document.querySelectorAll(".wizzy-common-select-selectedItem").forEach(function (el) {
      var key = el.textContent.trim();
      if (labels[key]) el.textContent = labels[key];
    });

    document.querySelectorAll("#wizzy-sort-select option").forEach(function (el) {
      var key = el.textContent.trim();
      if (labels[key]) el.textContent = labels[key];
    });
  }
  
      window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (data) {
      try {
      
        setTimeout(function () {
          initWizzyModalOpeners();
          initWizzyBulkAdd();
          initWizzySwatchClickRedirect();
          syncCartQuantities();
          translateWizzySortUI();
      document.addEventListener("click", function (e) {
        var btn = e.target.closest(".wizzy-search-wrapper .button_switcher .list_grid");
        if (!btn) return;

        var switcher = btn.closest(".button_switcher");
        if (!switcher) return;

        switcher.querySelectorAll(".list_grid").forEach(function (el) {
          el.classList.remove("active");
        });

        btn.classList.add("active");

        var wrapper = document.querySelector(".wizzy-search-wrapper");
        if (!wrapper) return;

        var results = wrapper.querySelector(".wizzy-search-results");
        if (!results) return;

        var grid = results.querySelector("#product-grid");

        var baseClasses = [
          "listt-card",
          "grid",
          "grid--2-col-tablet-down",
          "grid--3-col-desktop",
          "collection-quick-add-bulk"
        ];

        var listClass = "product-list";
        var galleryClass = "product-gallery";

        // Remove classes first
        results.classList.remove(...baseClasses, listClass);
        if (grid) grid.classList.remove(...baseClasses, galleryClass);

        if (btn.classList.contains("show_list")) {
          wrapper.setAttribute("wizzy-tile-view-level", "1");
          results.classList.add(...baseClasses, listClass);
        } 
        else if (btn.classList.contains("show_grid")) {
          wrapper.setAttribute("wizzy-tile-view-level", "3");
        } 
        else if (btn.classList.contains("show_gallery")) {
          wrapper.setAttribute("wizzy-tile-view-level", "5");
          if(window.innerWidth < 768)
          if (grid) grid.classList.add(...baseClasses, galleryClass);
        }
      });
    document.addEventListener("keydown", function (e) {
      var btn = e.target.closest(".wizzy-search-wrapper .button_switcher .list_grid");
      if (!btn || e.keyCode !== 13) return;
      e.preventDefault();
      btn.click();
    });
    }, 150);


                if (window.innerWidth < 768) {

                var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

                if (sourceElement) {
                    var clonedContent = sourceElement.cloneNode(true);
                    var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");

                    if (targetDiv && !targetDiv.querySelector(".wizzy-search-sort-wrapper")) {
                        targetDiv.appendChild(clonedContent);
                    }
                }

                var sortInFilter = document.querySelector(
                    ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
                );

                if (sortInFilter && !sortInFilter.classList.contains("click-listener-attached")) {

                    sortInFilter.addEventListener("click", function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        var sortOptions = document.querySelector(
                            ".wizzy-sort-wrapper-in-filter .wizzy-common-select-options"
                        );

                        if (sortOptions) {
                            if (sortOptions.style.display === "none" || sortOptions.style.display === "") {
                                sortOptions.style.display = "grid";
                            } else {
                                sortOptions.style.display = "none";
                            }
                        }
                    });

                    sortInFilter.classList.add("click-listener-attached");
                }
            }

        document.querySelectorAll('.wizzy-search-results').forEach(el => {
  if (el.getAttribute('wizzy-tile-view-level') === '1') {
    el.classList.add(
      'listt-card',
      'grid',
      'grid--2-col-tablet-down',
      'grid--3-col-desktop',
      'collection-quick-add-bulk',
      'product-list'
    );
  }
});

document.querySelectorAll('.wizzy-search-results').forEach(el => {
  const level = el.getAttribute('wizzy-tile-view-level');

  if (level === '5') {
    const grid = el.querySelector('#product-grid');
    if (grid) {
      grid.classList.add(
        'listt-card',
        'grid',
        'grid--2-col-tablet-down',
        'grid--3-col-desktop',
        'collection-quick-add-bulk',
        'product-gallery'
      );
    }
  }
});
document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest(".mobile-facets__close.mobile-facets__close--no-js");
  if (!closeBtn) return;

  const wizzyClose = document.querySelector(".wizzy-filters-close-btn");
  if (wizzyClose) {
    wizzyClose.click();
  }
});
      } catch (error) {
        console.log("error",error);
      }
      return data;
      });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
      try {
        

        setTimeout(function () {
          initWizzyModalOpeners();
          initWizzyBulkAdd();
          initWizzySwatchClickRedirect();
          syncCartQuantities();
          translateWizzySortUI();
      document.addEventListener("click", function (e) {
        var btn = e.target.closest(".wizzy-search-wrapper .button_switcher .list_grid");
        if (!btn) return;

        var switcher = btn.closest(".button_switcher");
        if (!switcher) return;

        switcher.querySelectorAll(".list_grid").forEach(function (el) {
          el.classList.remove("active");
        });

        btn.classList.add("active");

        var wrapper = document.querySelector(".wizzy-search-wrapper");
        if (!wrapper) return;

        var results = wrapper.querySelector(".wizzy-search-results");
        if (!results) return;

        var grid = results.querySelector("#product-grid");

        var baseClasses = [
          "listt-card",
          "grid",
          "grid--2-col-tablet-down",
          "grid--3-col-desktop",
          "collection-quick-add-bulk"
        ];

        var listClass = "product-list";
        var galleryClass = "product-gallery";

        // Remove classes first
        results.classList.remove(...baseClasses, listClass);
        if (grid) grid.classList.remove(...baseClasses, galleryClass);

        if (btn.classList.contains("show_list")) {
          wrapper.setAttribute("wizzy-tile-view-level", "1");
          results.classList.add(...baseClasses, listClass);
        } 
        else if (btn.classList.contains("show_grid")) {
          wrapper.setAttribute("wizzy-tile-view-level", "3");
        } 
        else if (btn.classList.contains("show_gallery")) {
          wrapper.setAttribute("wizzy-tile-view-level", "5");
          if(window.innerWidth < 768)
          if (grid) grid.classList.add(...baseClasses, galleryClass);
        }
      });
    document.addEventListener("keydown", function (e) {
      var btn = e.target.closest(".wizzy-search-wrapper .button_switcher .list_grid");
      if (!btn || e.keyCode !== 13) return;
      e.preventDefault();
      btn.click();
    });
    }, 150);


                if (window.innerWidth < 768) {

                var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

                if (sourceElement) {
                    var clonedContent = sourceElement.cloneNode(true);
                    var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");

                    if (targetDiv && !targetDiv.querySelector(".wizzy-search-sort-wrapper")) {
                        targetDiv.appendChild(clonedContent);
                    }
                }

                var sortInFilter = document.querySelector(
                    ".wizzy-search-filters-left-wrapper .wizzy-common-select-selector"
                );

                if (sortInFilter && !sortInFilter.classList.contains("click-listener-attached")) {

                    sortInFilter.addEventListener("click", function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        var sortOptions = document.querySelector(
                            ".wizzy-sort-wrapper-in-filter .wizzy-common-select-options"
                        );

                        if (sortOptions) {
                            if (sortOptions.style.display === "none" || sortOptions.style.display === "") {
                                sortOptions.style.display = "grid";
                            } else {
                                sortOptions.style.display = "none";
                            }
                        }
                    });

                    sortInFilter.classList.add("click-listener-attached");
                }
            }

        document.querySelectorAll('.wizzy-search-results').forEach(el => {
  if (el.getAttribute('wizzy-tile-view-level') === '1') {
    el.classList.add(
      'listt-card',
      'grid',
      'grid--2-col-tablet-down',
      'grid--3-col-desktop',
      'collection-quick-add-bulk',
      'product-list'
    );
  }
});

document.querySelectorAll('.wizzy-search-results').forEach(el => {
  const level = el.getAttribute('wizzy-tile-view-level');

  if (level === '5') {
    const grid = el.querySelector('#product-grid');
    if (grid) {
      grid.classList.add(
        'listt-card',
        'grid',
        'grid--2-col-tablet-down',
        'grid--3-col-desktop',
        'collection-quick-add-bulk',
        'product-gallery'
      );
    }
  }
});
document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest(".mobile-facets__close.mobile-facets__close--no-js");
  if (!closeBtn) return;

  const wizzyClose = document.querySelector(".wizzy-filters-close-btn");
  if (wizzyClose) {
    wizzyClose.click();
  }
});
      } catch (error) {
        console.log("error",error);
      }
        return data;
      }
    );


    function destroyAutocompleteSwipers() {
      document.querySelectorAll('.wizzy-autocomplete-wrapper .swipecollection').forEach(function (el) {
        if (el._swiperDestroyed) return;
        if (el.swiper && typeof el.swiper.destroy === 'function') {
          el.swiper.destroy(true, true);
          el._swiperDestroyed = true;
        }
      });
    }

        const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
    }
    const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
    }
      , callback = function (mutationsList, observer2) {
        for (const mutation of mutationsList) {
          updateBodyClass();
          destroyAutocompleteSwipers();
          break
        }
      }
    ,observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());
  };
  